import { getType, types } from "mobx-state-tree";
import { FormattedMessage } from "react-intl";
import React from "react";
import lodash from "lodash";
import UserStore from "../../../../../stores/domain/UserStore";

const ExportType = types.model('ExportType', {
  type: types.string,
  label: types.string
});


export const DataExportFilterSelectState = types.model('DataExportFilterSelectState',{
  selectStateUuid: types.maybe(types.identifier),
  userStore: types.maybe(types.late(() => types.reference(UserStore))),
  statusTypes: types.optional(types.array(types.string), []),
  exportTypes: types.optional(types.array(ExportType), []),
}).volatile(self => ({
  notifySelect: types.f,
  selected: types.array,
  emails: types.array,
  createdByUsers: types.array,
  updatedByUsers: types.array,
  tags: types.array
})).actions((self)=>({
  reset(){
    self.selected = [];
  },
  setEmails(emails) {
    self.emails = emails
  },
  setCreatedByUsers(users) {
    self.createdByUsers = users
  },
  setUpdatedByUsers(users) {
    self.updatedByUsers = users
  },
  setStatusTypes(status) {
    self.statusTypes = status
  },
  setExportTypes(types) {
    self.exportTypes = types
  },
  filterChange(data){
    self.selected = data;
    self.notifySelect(lodash.reduce(data, function(result, value, key) {
      const parts = value.value.split('.');
      const pushValue = parts[parts.length-1];
      const fieldName = value.value.substr(0, value.value.length - pushValue.length - 1 );
      (result[fieldName] || (result[fieldName] = [])).push(pushValue);
      return result;
    }, {}), ["createdBy", "modifiedBy", "status", "exportType"]);
  },
  setConsumer(f){
    self.notifySelect = f
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => {
      console.log("placeholder notifySelect")
    }
  }

})).views( (self) => ({
  optionValues() {

    const options = [];


    const createdByUserList = self?.createdByUsers || [];
    const updatedByUserList = self?.updatedByUsers || [];
    //
    const createdByOptions = createdByUserList
      .slice()
      .sort((a, b) => a?.email?.localeCompare(b?.email))
      .flatMap((user) => ({
        label: user?.email,
        value: "createdBy." + user.uuid
      }));

    const modifiedByOptions = updatedByUserList
      .slice()
      .sort((a, b) => a?.email?.localeCompare(b?.email))
      .flatMap((user) => ({
        label: user?.email,
        value: "modifiedBy." + user.uuid
      }));

    options.push({
      label: <FormattedMessage id="listCodes.filter.filterBy.users.defaultMessage"/>,
      options: createdByOptions
    });

    options.push({
      label: <FormattedMessage id="listCodes.filter.filterBy.modifiedBy.defaultMessage"/>,
      options: modifiedByOptions
    });

    const statusTypes = self?.statusTypes || [];
    const statusOptions = statusTypes.flatMap( (stat) =>{
      return {
        label: stat,
        value: "status."+stat
      }
    });

    options.push({
      label: <FormattedMessage id="listCodes.filter.filterBy.status.defaultMessage"/>,
      options: statusOptions
    });

    const exportTypes = self?.exportTypes || [];
    const exportTypeOptions = exportTypes.flatMap( (typeObj) =>{
      return {
        label: typeObj.label,
        value: "exportType." + typeObj.type
      }
    });

    options.push({
      label: <FormattedMessage id="listCodes.filter.filterBy.exportType.defaultMessage"/>,
      options: exportTypeOptions
    });

    return options;
  }
}))
